import * as wActs from './website-actions.js';
import * as wConst from '../consts/website-consts';
import { fetch, addTask } from "domain-task";
import * as pConsts from "../consts/profiles-consts";
import {getBearer, isNullOrEmpty} from "./website-actions";


export function getFeaturedLinks(term,catId,cc,city,page="1") {
  return (dispatch,getState) => {
    dispatch({type: wConst.FETCH_FEATUREDLINKS_PENDING, payload: true});
    let state = getState();
    let pageObj = state.Website.Page;
    let ref = wActs.GetReferer();
    if(wActs.isNullOrEmpty(ref)) {
      ref = state.Website.ServerParams.Referer;
    }
    let lang = getLanguage(new URL(ref).pathname);

    let headers = {
      'X-Alt-Referer': ref,
      'X-Alt-Language': lang,
    };
    let qStr = "";
    let query = "";
    let place = "/";
    let inc = "";
    if (typeof document !== "undefined") {
      qStr = document.location.toString();
    } else {
      qStr = "http://www.fakeurl.com/" + state.Website.ServerParams.Query;
    }

    if(!wActs.isNullOrUndefined(pageObj.Settings) && !wActs.isNullOrEmpty(pageObj.Settings.Include)) {
      inc = pageObj.Settings.Include;
      cc="";city="";
    } else {
      if(wActs.getParameterByName("term",qStr,"") != "") {
        term = wActs.getParameterByName("term",qStr);
      }
      if(wActs.getParameterByName("country",qStr,"") != "") {
        cc = wActs.getParameterByName("country",qStr);
      }
      if(wActs.getParameterByName("city",qStr,"") != "") {
        city = wActs.getParameterByName("city",qStr);
      }
    }
    if(wActs.getParameterByName("page",qStr,"") != "") {
      page = wActs.getParameterByName("page",qStr);
    }

    //try {
    //  if (!wActs.isNullOrEmpty(state.Website.Request.CountryCode) && wActs.isNullOrEmpty(cc)) {
    //    cc = state.Website.Request.CountryCode;
    //  }
    //} catch (e) { }


    let qry = "?pageSize=12";
    if(!wActs.isNullOrEmpty(term)) { qry += '&term=' + encodeURIComponent(term)}
    if(!wActs.isNullOrEmpty(catId)) { qry += '&categoryId=' + encodeURIComponent(catId)}
    if(!wActs.isNullOrEmpty(cc)) { qry += '&countryCode=' + encodeURIComponent(cc)}
    if(!wActs.isNullOrEmpty(city)) { qry += '&city=' + encodeURIComponent(city)}
    if(!wActs.isNullOrEmpty(page)) { qry += '&page=' + encodeURIComponent(page)}
    if(!wActs.isNullOrEmpty(inc)) { qry += '&include=' + encodeURIComponent(inc)}

    let gLnks = fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/links${qry}`, {headers: headers})
      .then(resp => {
        return resp.json();
      })
      .then(function (data) {

        if(data.Code == 200) {
          dispatch({type: wConst.FETCH_FEATUREDLINKS_FULLFILLED, payload: data});
        } else {
          dispatch({type: wConst.FETCH_FEATUREDLINKS_REJECTED, payload: data});
        }
      }).catch(function (ex) {
        dispatch(wActs.showWarning("WARN", "Could not load links data",2500));
        dispatch({type: wConst.FETCH_FEATUREDLINKS_REJECTED, payload: ex.toString()});
        return;
      }
    );
    addTask(gLnks);
  };
}


export function getLanguage(cult,web) {
  if (cult == "/" || wActs.isNullOrEmpty(cult)) {
    return "ENGLISH";
  }
  if (cult.startsWith("/nl/") || cult.endsWith("/nl")) { return "DUTCH"; }
  if (cult.startsWith("/ru/") || cult.endsWith("/ru")) { return "RUSSIAN"; }
  if (cult.startsWith("/rs/") || cult.endsWith("/rs")) { return "SERBIAN"; }
  if (cult.startsWith("/ro/") || cult.endsWith("/ro")) { return "ROMANIAN"; }
  if (cult.startsWith("/cz/") || cult.endsWith("/cz")) { return "CZECH"; }
  if (cult.startsWith("/it/") || cult.endsWith("/it")) { return "ITALIAN"; }
  if (cult.startsWith("/tr/") || cult.endsWith("/tr")) { return "TURKISH"; }
  return "ENGLISH";
}


export function getCategoryLinks(term,catId,cc,city,page="1") {
  return (dispatch,getState) => {
    dispatch({type: wConst.FETCH_CATEGORYLINKS_PENDING, payload: true});
    let state = getState();
    let ref = wActs.GetReferer();
    let pageObj = state.Website.Page;
    if(wActs.isNullOrEmpty(ref)) {
      ref = getState().Website.ServerParams.Referer;
    }
    let lang = getLanguage(new URL(ref).pathname);

    let headers = {
      'X-Alt-Referer': ref,
      'X-Alt-Language': lang,
    };

    //console.log("PageInfo",page);


    let qStr = "";
    let inc = "";
    let query = "";
    let place = "/";
    if (typeof document !== "undefined") {
      qStr = document.location.toString();
    } else {
      qStr = "http://www.fakeurl.com/" + state.Website.ServerParams.Query;
    }

    if(!wActs.isNullOrUndefined(pageObj.Settings) && !wActs.isNullOrEmpty(pageObj.Settings.Include)) {
      inc = pageObj.Settings.Include;
      cc=wActs.isNullOrUndefined(pageObj.Template.Country) ? "" : pageObj.Template.Country.Code;
      city="";
    } else {
      if (wActs.getParameterByName("term", qStr, "") != "") {
        term = wActs.getParameterByName("term", qStr);
      }
      if (wActs.getParameterByName("country", qStr, "") != "") {
        cc = wActs.getParameterByName("country", qStr);
      }
      if (wActs.getParameterByName("city", qStr, "") != "") {
        city = wActs.getParameterByName("city", qStr);
      }
    }
    if (wActs.getParameterByName("page", qStr, "") != "") {
      page = wActs.getParameterByName("page", qStr);
    }

    //try {
    // if (!wActs.isNullOrEmpty(state.Website.Request.CountryCode) && wActs.isNullOrEmpty(cc)) {
    //    cc = state.Website.Request.CountryCode;
    //  }
    //} catch (e) { }


    let qry = "?pageSize=1000";
    if(!wActs.isNullOrEmpty(term)) { qry += '&term=' + encodeURIComponent(term)}
    if(!wActs.isNullOrEmpty(catId)) { qry += '&categoryId=' + encodeURIComponent(catId)}
    if(!wActs.isNullOrEmpty(cc)) { qry += '&countryCode=' + encodeURIComponent(cc)}
    if(!wActs.isNullOrEmpty(city)) { qry += '&city=' + encodeURIComponent(city)}
    if(!wActs.isNullOrEmpty(page)) { qry += '&page=' + encodeURIComponent(page)}
    if(!wActs.isNullOrEmpty(inc)) { qry += '&include=' + encodeURIComponent(inc)}

    let gLnks = fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/links/categories${qry}`, {headers: headers})
      .then(resp => {
        return resp.json();
      })
      .then(function (data) {

        if(data.Code == 200) {
          dispatch({type: wConst.FETCH_CATEGORYLINKS_FULLFILLED, payload: data});
        } else {
          dispatch({type: wConst.FETCH_CATEGORYLINKS_REJECTED, payload: data});
        }
      }).catch(function (ex) {
          dispatch(wActs.showWarning("WARN", "Could not load category links data",2500));
          dispatch({type: wConst.FETCH_CATEGORYLINKS_REJECTED, payload: ex.toString()});
          return;
        }
      );
    addTask(gLnks);
  };
}

export function getSubLinks(term,cc,catid,city) {
  return (dispatch,getState) => {
    dispatch({type: wConst.GET_SUBLINKS_PENDING, payload: true});
    let state = getState();
    let ref = wActs.GetReferer();
    let lang = state.Website.Settings.SelectedLang;
    if(wActs.isNullOrEmpty(ref)) {
      ref = state.Website.ServerParams.Referer;
    }
    let headers = {
      'X-Alt-Referer': ref,
      'X-Alt-Language': lang,
    };

    let qry = "?pageSize=15&match=2";



    if(!wActs.isNullOrEmpty(term)) { qry += '&term=' + encodeURIComponent(term)}
    if(!wActs.isNullOrEmpty(cc)) { qry += '&countryCode=' + encodeURIComponent(cc)}
    if(!wActs.isNullOrUndefined(catid)) { qry += '&categoryId=' + catid}
    if(!wActs.isNullOrEmpty(city)) { qry += '&city=' + city}
    let sLnks = fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/links${qry}`, {headers: headers})
      .then(resp => {
        return resp.json();
      })
      .then(function (data) {

        if(data.Code == 200) {
          dispatch({type: wConst.GET_SUBLINKS_FULFILLED, payload: data});
        } else {
          dispatch({type: wConst.GET_SUBLINKS_REJECTED, payload: data});
        }
      }).catch(function (ex) {
          dispatch(wActs.showWarning("WARN", "Could not load Sublinks data",2500));
          dispatch({type: wConst.GET_SUBLINKS_REJECTED, payload: {Code: 500, Message: ex.toString()}});
          return;
        }
      );
    addTask(sLnks);
  };
}


export function submitLink(dta) {
  return (dispatch,getState) => {
    dispatch({type: wConst.SUBMIT_LINK_PENDING, payload: true});
    let ref = wActs.GetReferer();
    if(wActs.isNullOrEmpty(ref)) {
      ref = getState().Website.ServerParams.Referer;
    }
    let headers = {
      'X-Alt-Referer': ref,
    };
    let bear = getBearer(getState().Website.ServerParams.Cookies);
    if(!wActs.isNullOrEmpty(bear)) {
      headers.Authorization = "Bearer " + bear;
    }
    let qry = "?";
    if(!wActs.isNullOrUndefined(dta.url)) { qry += '&url=' + encodeURIComponent(dta.url);}
    if(!wActs.isNullOrUndefined(dta.title)) { qry += '&title=' + encodeURIComponent(dta.title);}
    if(!wActs.isNullOrUndefined(dta.description)) { qry += '&description=' + encodeURIComponent(dta.description);}
    if(!wActs.isNullOrUndefined(dta.countryCode)) { qry += '&countryCode=' + encodeURIComponent(dta.countryCode);}
    if(!wActs.isNullOrUndefined(dta.city)) { qry += '&city=' + encodeURIComponent(dta.city);}
    if(!wActs.isNullOrUndefined(dta.categoryId)) { qry += '&categoryId=' + encodeURIComponent(dta.categoryId);}
    if(!wActs.isNullOrUndefined(dta.summary)) { qry += '&summary=' + encodeURIComponent(dta.summary);}
    if(!wActs.isNullOrUndefined(dta.body)) { qry += '&body=' + encodeURIComponent(dta.body);}
    if(!wActs.isNullOrUndefined(dta.img)) { qry += '&bannerUrl=' + encodeURIComponent(dta.img);}
    if(!wActs.isNullOrUndefined(dta.email)) { qry += '&emailAddress=' + encodeURIComponent(dta.email);}
    if(!wActs.isNullOrUndefined(dta.backlinkurl)) { qry += '&backlinkUrl=' + encodeURIComponent(dta.backlinkurl);}

    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/links/submit${qry}`, {method: "POST",headers: headers})
      .then(resp => {
        if(resp.status == 404) {
          return {Code: 404, Message: "Invalid URL"};
        }
        if(resp.status == 401 || resp.status == 403) {
          return {Code: 401, Message: "Not Authorized"};
        }
        return resp.json();
      })
      .then(function (data) {
        if(data.Code == 200) {
          dispatch({type: wConst.SUBMIT_LINK_FULFILLED, payload: data});
          dispatch(wActs.showWarning("INFO", data.Message,5000));
        } else {
          dispatch({type: wConst.SUBMIT_LINK_REJECTED, payload: data});
          dispatch(wActs.showWarning("WARN", data.Message,5000));
        }
      }).catch(function (ex) {
          dispatch({type: wConst.SUBMIT_LINK_REJECTED, payload: {Code: 500, Message: "Internal error"}});
          dispatch(wActs.showWarning("ERROR", "Internal Error: " + ex.toString(),5000));
          return;
        }
      );

  };
}


